import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Toolbar } from 'primereact/toolbar';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';

import api from './../../service/api';
import { formatCurrency } from '../../service/format';

import CardCompare from './CardCompare';

export default function Viability(){
    var emptySupplier = {
        code: null,
        name: '',
        document_number: '',
        phone: '',
        address: ''
    }
   
    const history = useHistory();
    const [viability, setViability] = useState(emptySupplier);
    const [viabilities, setViabilities] = useState([]);
    const [deleteDialog, setDeleteDialog] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [globalFilter, setGlobalFilter] = useState(null);
    const [selected, setSelected] = useState(null);

    const toast = useRef(null);
    const dt = useRef(null);

    const confirmDelete = (_viability) => {
        setViability({ ..._viability });
        setDeleteDialog(true);
    }

    const hideDeleteDialog = () => {
        setViability({ ...emptySupplier });
        setDeleteDialog(false);
    }

    const listViability = () => {
        api().get('/viability/list').then(response => {
            if(response.status === 200 && response.data.result){
                setViabilities(response.data.data);
            }
        });
    }

    const handleDelete = () => {
        setDisabled(true);
        api().delete('/viability/' + viability.code).then(response => {
            if(response.status === 200 && response.data.result) {
                toast.current.show({severity: 'success', summary: 'Sucesso', detail: response.data.message});
                listViability();
            } else toast.current.show({severity: 'error', summary: 'Erro', detail: response.data.message});
            setViability(emptySupplier);
            setDeleteDialog(false);
        });
    }

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    <Button label="Nova Viabilidade" icon="pi pi-plus" className="p-button-success mr-2" onClick={() => {
                        history.push('viability/create');
                    }} />
                </div>
            </React.Fragment>
        )
    }

    const header = (
        <>
            <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                <h5 className="m-0">Viabilidade</h5>
                <span className="block mt-2 md:mt-0 p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Pesquisar..." />
                </span>
                
            </div>
            <div>
                <small>*Selecione as viabilidades desejadas para realizar a comparação</small>
            </div>
        </>
        
    );

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions">
                <Button icon="pi pi-trash" className="p-button-rounded p-button-danger mt-2 mr-2" onClick={() => confirmDelete(rowData)} />
                <Button icon="pi pi-ellipsis-v" className="p-button-rounded" onClick={() => {
                    history.push('viability/' + rowData.code);
                }} />
            </div>
        );
    }

    const deleteDialogFooter = (
        <>
            { !disabled && <Button label="Não" icon="pi pi-times" className="p-button-text" onClick={hideDeleteDialog} />}
            <Button label="Sim" icon="pi pi-check" loading={disabled} className="p-button-text" onClick={handleDelete} />
        </>
    );

    useEffect(() => {
        listViability();
    }, []);

    return (
        <div className="grid crud-demo">
            <div className="col-12">
                <div className="card">
                    <Toast ref={toast} />
                    <Toolbar className="mb-4" left={leftToolbarTemplate}></Toolbar>

                    <DataTable ref={dt} value={viabilities} 
                        dataKey="code" paginator rows={5} rowsPerPageOptions={[5, 10, 25]} className="datatable-responsive"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Listando {first} a {last} de {totalRecords} registros"
                        globalFilter={globalFilter} emptyMessage="Nenhum registro encontrado." header={header} responsiveLayout="scroll"
                        selection={selected} onSelectionChange={e => setSelected(e.value)}>
                        <Column selectionMode="multiple" headerStyle={{width: '3em'}}></Column>
                        <Column field="description" sortable header="Descrição"></Column>
                        <Column body={rowData => formatCurrency(rowData.shipping_price || 0, true)} header="Valor Frete"></Column>
                        <Column body={rowData => formatCurrency(rowData.routes.reduce((previous, current) => previous + current.total_tolls, 0) || 0, true)}  header="Valor Pedágios"></Column>
                        <Column body={rowData => formatCurrency(rowData.routes.reduce((previous, current) => previous + current.distance, 0) || 0)} header="Distância"></Column>
                        <Column body={rowData => formatCurrency(rowData.routes.length || 0)} header="QTD. Rotas"></Column>
                        <Column body={actionBodyTemplate}></Column>
                    </DataTable>

                    <Dialog visible={deleteDialog} style={{ width: '450px' }} header="Atenção" modal footer={deleteDialogFooter} onHide={hideDeleteDialog}>
                        <div className="flex align-items-center justify-content-center">
                            <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                            {viability && <span>Você tem certeza que deseja remover esta viabilidade?</span>}
                        </div>
                    </Dialog>
                </div>
            </div>
            <div className="col-12">
                <CardCompare viabilities={(selected || []).map(viability => {
                    var multiplicator = viability.isempty ? 2 : 1;
                    var distance = viability.routes.reduce((previous, route) => previous + route.distance, 0) * multiplicator;
                    var totalTolls = viability.routes.reduce((previous, route) => previous + route.total_tolls, 0) * multiplicator;
                    var costFuel = distance / (viability.average_consumption || 1) * viability.fuel_price;
                    var commission = viability.commission;
                    var cost = totalTolls + costFuel + commission + (viability.depreciation || 0);

                    return {
                        title: viability.description,
                        key: viability.code,
                        values: [
                            { label: 'Caminhão', value: viability.plate },
                            { label: 'Considerar Volta Vazio?', value: viability.isempty ? "Não" : "Sim" },
                            { label: 'Distância', value: formatCurrency(distance) + ' Km' },
                            { label: 'Valor Frete', value: formatCurrency(viability.shipping_price || 0, true) },
                            { label: 'Valor Comissão', value: formatCurrency(commission, true)},
                            { label: 'Valor Combustível', value: formatCurrency(viability.fuel_price || 0, true) },
                            { label: 'Depreciação', value: formatCurrency(viability.depreciation || 0, true) },
                            { label: 'Custo Pedágio', value: formatCurrency(totalTolls, true)},
                            { label: 'Custo Combustível', value: formatCurrency(costFuel, true) },
                            { label: 'Custo Total', value: formatCurrency(cost, true) },
                            { label: 'Lucro', value: formatCurrency((viability.shipping_price - cost), true) }
                        ]
                    }
                })} />
            </div>
        </div>
    );    
}